function hideMap() {
  document.querySelector(".valid_address_map").src = "";

  document.querySelector(".valid_address_map").alt = "";
}

function displayMap(latitiude, longitude) {
  document.querySelector(".valid_address_map").src =
    `https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyBOw5xMLo3DGb1ibO2tt_rNGWHI8i12e3U&center=${latitiude},${longitude}&zoom=14&size=960x250&maptype=roadmap&&markers=label:%95%7C${latitiude},${longitude}&v=weekly`;

  document.querySelector(".valid_address_map").alt =
    "pin at the location of inputted address on the map";
} // end displayMap def

function createBlankAddressObject() {
  return {
    geo: null,
    country: "United States",
    country_name: null,
    province_code: null,
    province: null,
    county: null,
    city: null,
    zip: null,
    street: null,
    streetNumber: null,
    unitNumber: null,
    address1: null,
    address2: null,
    phone: null,
    googlePlacesId: null,
    demographicSurveyResult: null,
  };
}

function convertGooglePlaceToAddressObject(place) {
  const address = createBlankAddressObject();

  const placesAddress = place?.address_components;

  if (!placesAddress) {
    return address;
  }

  const lat = place.geometry.location.lat();
  const lng = place.geometry.location.lng();

  // Save the individual address components.
  address.geo = {
    lat: lat,
    long: lng,
  };

  address.googlePlacesId = place.place_id;

  for (let i = 0; i < placesAddress.length; i++) {
    const component = placesAddress[i].types[0];

    switch (component) {
      case "country":
        address.country_name = placesAddress[i]["long_name"];
        address.country = placesAddress[i]["long_name"];
        address.country_code = "US";
        break;
      case "administrative_area_level_1":
        address.province = placesAddress[i]["long_name"];
        address.province_code = "MN";
        address.state = "MN";
        break;
      case "locality":
        address.city = placesAddress[i]["long_name"];
        break;
      case "postal_town":
      case "sublocality":
      case "sublocality_level_1":
      case "administrative_area_level_3":
        if (!address.city) {
          address.city = placesAddress[i]["long_name"];
        }
        break;
      case "postal_code":
        address.zip = placesAddress[i]["long_name"];
        break;
      case "route":
        address.street = placesAddress[i]["long_name"];
        break;
      case "street_number":
        address.streetNumber = placesAddress[i]["long_name"];
        break;
      case "subpremise":
        address.unitNumber = placesAddress[i]["long_name"];
        break;
      case "administrative_area_level_2":
        if (placesAddress[i]["long_name"].match(/County$/)) {
          address.county = placesAddress[i]["long_name"];
        }
        break;
      default:
        break;
    }
  }

  // Build address1 with street number and street name
  if (address.streetNumber && address.street) {
    address.address1 = address.streetNumber + " " + address.street;
  } else if (address.street) {
    address.address1 = address.street;
  } else {
    address.address1 = null;
  }

  if (!address.streetNumber && place?.formatted_address) {
    const formattedStreetNumber = place.formatted_address.match(/^\d+/)?.[0];
    if (formattedStreetNumber) {
      address.streetNumber = formattedStreetNumber;
      if (address.street) {
        address.address1 = address.streetNumber + " " + address.street;
      }
    }
  }

  return address;
}
